import "$styles/index.css";
import "$styles/brands.bareminimum.css";
import "$styles/fontawesome.bareminimum.css";
import "$styles/solid.css";
import * as Turbo from "@hotwired/turbo";

/**
 * Adds support for declarative shadow DOM. Requires your HTML <head> to include:
 * `<meta name="turbo-cache-control" content="no-cache" />`
 */
import * as TurboShadow from "turbo-shadow";

/**
 * Uncomment the line below to add transition animations when Turbo navigates.
 * Use data-turbo-transition="false" on your <main> element for pages where
 * you don't want any transition animation.
 */
// import "./turbo_transitions.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}";

async function copyTextToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

function setCopyButtonState(button, label) {
  button.textContent = label;
}

document.addEventListener("click", async event => {
  const button = event.target.closest("[data-copy-material-markdown]");
  if (!button) return;

  const source = document.getElementById("material-markdown-payload");
  if (!source) return;

  const defaultLabel = button.dataset.defaultLabel || "Copy as Markdown";
  const successLabel = button.dataset.successLabel || "Copied";
  const errorLabel = button.dataset.errorLabel || "Copy failed";

  try {
    await copyTextToClipboard(source.value || "");
    setCopyButtonState(button, successLabel);
  } catch (_error) {
    setCopyButtonState(button, errorLabel);
  } finally {
    window.setTimeout(() => {
      setCopyButtonState(button, defaultLabel);
    }, 1500);
  }
});

let activeBlogThumbLink = null;

function hideBlogCursorPreview() {
  const preview = document.getElementById("blog-cursor-preview");
  if (!preview) return;
  preview.classList.remove("is-visible");
}

function moveBlogCursorPreview(clientX, clientY) {
  const preview = document.getElementById("blog-cursor-preview");
  if (!preview) return;

  const offsetX = 20;
  const offsetY = 16;
  const previewWidth = 192; // 12rem
  const previewHeight = 112; // 7rem

  let left = clientX + offsetX;
  let top = clientY + offsetY;

  if (left + previewWidth > window.innerWidth - 8) {
    left = clientX - previewWidth - 12;
  }
  if (top + previewHeight > window.innerHeight - 8) {
    top = clientY - previewHeight - 12;
  }

  preview.style.transform = `translate(${left}px, ${top}px) scale(1)`;
}

document.addEventListener("mouseover", event => {
  const link = event.target.closest("a[data-blog-thumb]");
  if (!link) return;

  if (window.matchMedia("(max-width: 767px)").matches) return;

  const preview = document.getElementById("blog-cursor-preview");
  const image = document.getElementById("blog-cursor-preview-image");
  if (!preview || !image) return;

  activeBlogThumbLink = link;
  image.src = link.dataset.blogThumb || "";
  image.alt = `Thumbnail for ${link.textContent?.trim() || "post"}`;
  preview.classList.add("is-visible");
});

document.addEventListener("mouseout", event => {
  const fromThumbLink = event.target.closest("a[data-blog-thumb]");
  if (!fromThumbLink) return;

  const toElement = event.relatedTarget;
  if (toElement && fromThumbLink.contains(toElement)) return;

  activeBlogThumbLink = null;
  hideBlogCursorPreview();
});

document.addEventListener("mousemove", event => {
  if (!activeBlogThumbLink) return;
  moveBlogCursorPreview(event.clientX, event.clientY);
});
